import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";



function ModalEnableClientPerm(props) {
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const [text, setText] = useState();

  async function handleEnableClient(e) {
    e.preventDefault();
    const response = await api.put('/client/enable/perm/' + props.props.id, {
    });
    if (response.status === 200) {
      if (response.data === false) {
        setText("Cliente habilitado com sucesso")
      } else {
        setText("Cliente desabilitado com sucesso")
      }
      setControlSnack(true);
      props.getAllClients();
      setTimeout(function () {
        props.onHide();
      }, 1500);
    }
  }

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (controlSnack) {
      showNotification("br")
    }
  }, [controlSnack]);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Habilitar/desabilitar cliente
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleEnableClient}>
        <Modal.Body>
          <h4> Tem certeza que deseja habilitar/desabilitar esse cliente permanentimente?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Habilitar/desabilitar
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message={text}
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalEnableClientPerm;